module.exports = __webpack_public_path__ + "static/media/afl-pro-txt.557e4c13.svg";